// extracted by mini-css-extract-plugin
export default {"id":"wtQfvf9qAz","confirm-input":"RTM6Dd42mB","confirmInput":"RTM6Dd42mB","hard-delete-checkbox":"biGYdvU6ob","hardDeleteCheckbox":"biGYdvU6ob"};